import {fetchJson} from '../utils/fetch_utils';
import * as ActionTypes from './actionTypes';
import {clearLoadingMessage, error} from './index';

// src_location_change indicates if the source of the action was a URL Location Change
export const toggleBoundary = (layer_prefix, src_location_change = false) => {
  return {
    type: ActionTypes.TOGGLE_BOUNDARY,
    layer_prefix,
    src_location_change
  };
};

// src_location_change indicates if the source of the action was a URL Location Change
export const activateBoundary = (layer_prefix, src_location_change = false) => {
  return {
    type: ActionTypes.ACTIVATE_BOUNDARY,
    layer_prefix: layer_prefix,
    src_location_change
  };
};

export const populateBoundaryAsync = (boundary) => {
  const now = new Date().toISOString();

  return (dispatch) =>
    fetchJson(boundary.source + '&time=' + now)
    .then(data => {
      dispatch(_populateBoundaryData(boundary, data));
    })
    .catch(err => {
      dispatch(clearLoadingMessage());
      dispatch(error('Call to get boundary data failed: ' + (err.message || err)));
    });
};

const _populateBoundaryData = (boundary, data) => {
  return {
    type: ActionTypes.POPULATE_BOUNDARY_DATA,
    layer_prefix: boundary.prefix,
    geojson: data
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_boundary_details.js